export interface SystemParam {
  id: number
  name: string
  description: string
  value: string
  isDeleted: boolean
}

export const EmptyParam = {
  id: 0,
  name: '',
  description: '',
  value: '',
  isDeleted: false
}
